import { REHYDRATE } from "redux-persist/lib/constants";
import { constants } from "../constants/redux-constants";

const initialState = {
  isUserLoggedIn: false,
  userData: {},
  activePersonId: '',
  personData: {},
  relatedPersons:[],
  currentUserSettings:{},
};

const userAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      return {
        ...state,
        ...action.payload?.auth || {},
      };
    case constants.RESET:
      return {
        ...initialState
      }
    case constants.USER_CHECK_LOGIN:
      return {
        ...state,
        isUserLoggedIn: true,
      };
    case constants.SET_PERSON_DATA:
      return {
        ...state,
        personData: action.payload,
      };
    case constants.USER_LOGOUT:
      sessionStorage.removeItem("x-access-token");
      sessionStorage.removeItem("user-access-details");
      sessionStorage.removeItem('persist:root')
      return {
        ...state,
        isUserLoggedIn: false,
        userData: {},
        activePersonId: '',
        relatedPersons:[]
      };
    case constants?.USER_DATA:
      return {
        ...state,
        userData: action?.payload
      };
    case constants?.RELATED_PERSONS_DATA:
      let activePersonId = state.activePersonId
      if (action?.payload?.findIndex(f => f.disabled === false && f.patientId === activePersonId) < 0) {
        activePersonId = action?.payload?.find(f => f.disabled === false)?.patientId || ''
      }
      return {
        ...state,
        relatedPersons: action?.payload,
        // activePersonId: state.activePersonId || action?.payload?.[0]?.patientId || ''
        activePersonId: activePersonId
      };
    case constants?.ACTIVE_PERSON_ID:
      return {
        ...state,
        activePersonId: action?.payload
      }
    case constants?.SET_CURRENT_USER_SETTINGS:
      return {
        ...state,
        currentUserSettings: action?.payload
      }
    default:
      return {
        ...state,
      };
  }
};

export default userAuthReducer;
